import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";

export const getActivityFeedList = async (params) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/activity_feed${newParams}`)
}

export const getActivityFeedDetail = async (id) => {
  return api({}, true).get(`/${PUBLIC_V1}/activity_feed/${id}`)
}

export const getActivityMarketingList = async (params) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/activity_marketing${newParams}`)
}

export const getActivityMarketingDetail = async (id, params) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/activity_marketing/${id}${newParams}`)
}
